import { Map } from 'immutable';
import { ASSETS_RESOURCE } from 'signoxe/api/resources';
import { FETCH_RESOURCE_SUCCESS, FILTER_ASSETS } from 'signoxe/constants/actionTypes';

export const assetTags = (state = Map(), action) => {
  if (action.type === FETCH_RESOURCE_SUCCESS &&
    action.resource === ASSETS_RESOURCE &&
    action.response &&
    action.response.entities &&
    action.response.entities.assets) {
    const assets = action.response.entities.assets;
    for (const key of Object.keys(assets)) {
      const asset = assets[key];
      for (const tag of asset.tags || []) {
        const defaultVal = Map({count: 0, name: tag, selected: false});
        state = state.update(tag, defaultVal,
          (tagVal: Map<string, any>) => tagVal.update('count', (count) => count + 1));
      }
    }
    return state;
  } else if (action.type === FILTER_ASSETS && action.filterBy === 'TAGS') {
    return state.updateIn([action.filter, 'selected'], (selected) => !selected);
  } else return state;
};

export default assetTags;



// WEBPACK FOOTER //
// ./src/reducers/tags.ts